{
  "nav": {
    "home": "Home",
    "pick": "Pick",
    "leaderboard": "Leaderboard",
    "profile": "Profile",
    "leagues": "Leagues",
    "active_league": "Active League"
  },
  "common": {
    "error_data": "Error loading data.",
    "stage": "Stage",
    "go": "GO",
    "back": "← Back",
    "one_day_race": "One Day Race",
    "tomorrow": "Tomorrow",
    "in_days_one": "Tomorrow",
    "in_days_many": "In {{count}} days",
    "in_days_other": "In {{count}} days",
    "at_hours": "At {{hours}}",
    "loading": "Loading...",
    "confirm": "CONFIRM",
    "logout": "LOGOUT",
    "in_days": "In {{count}} days",
    "error_generic": "An error occurred.",
    "optional": "optional",
    "tu": "YOU",
    "error_title": "Error",
    "send": "Send",
    "retry": "Retry",
    "load_error_title": "Can't load the data",
    "load_error_sub": "Check your connection and try again.",
    "stale_data": "Data may be out of date: showing saved data."
  },
  "home": {
    "participants": "participants",
    "section_results": "Latest results",
    "section_upcoming": "Upcoming races",
    "social": "Follow us on social",
    "onboarding_next": "Next →",
    "onboarding_start": "Start playing →",
    "onboarding_rules": "Read the rules",
    "section_picks": "Picks to do",
    "no_races": "No races to pick right now",
    "other_picks_one": "one more pick to do →",
    "other_picks_many": "{{count}} more picks to do →",
    "other_picks_other": "{{count}} more picks to do →",
    "stage_results": "Standings",
    "tab_stage": "STAGE",
    "tab_gc": "GC",
    "no_data": "No data available",
    "onboarding_step1_title": "Welcome to Virtua Cycling!",
    "onboarding_step1_body": "The fantasy game for professional cycling.",
    "onboarding_step2_title": "How it works",
    "onboarding_item1": "Choose your riders — Before each stage, pick the riders you're betting on. You have until the start.",
    "onboarding_item2": "Earn points — Your riders earn points based on their real finishing position in the stage and overall classification.",
    "onboarding_item3": "Create your league — Compete with other participants stage by stage and climb the overall standings.",
    "onboarding_step3_title": "You're ready!",
    "onboarding_step3_body": "You're in the Virtua Cycling League, the general league where everyone plays. Read the full rules to not miss anything.",
    "kofi_cta": "Enjoying the app? Buy us a beer!",
    "jersey_gc": "GC Leader Jersey",
    "jersey_pt": "Points Jersey",
    "jersey_gm": "KOM Jersey",
    "greeting": "Hi, {{name}}",
    "status_ready": "Picks confirmed for the next stage",
    "status_todo": "You haven't made your picks yet",
    "retry": "Try again"
  },
  "pick": {
    "live_label": "LIVE",
    "pick_done": "Picks already submitted — you can still change them",
    "no_pick_stage": "No picks found for this stage.",
    "error_load": "Error loading races.",
    "loading": "Loading...",
    "title": "Pick",
    "no_races_title": "No races available",
    "no_races_sub": "There are no races scheduled right now. Check back soon!",
    "banned_title": "Withdrawal from race",
    "banned_stages_one": "You missed 1 stage",
    "banned_stages_many": "You missed {{count}} stages",
    "banned_stages_other": "You missed {{count}} stages",
    "banned_detail": "You can follow results and other players' picks, but you cannot participate in this edition.",
    "banned_message": "See you next time!",
    "stage_finished": "Stage finished. Here are the submitted picks.",
    "live_alert": "Race in progress — lineups locked",
    "startlist_btn": "Start list",
    "startlist_title": "Start list",
    "startlist_search": "Search bib or name",
    "startlist_dnf": "Withdrawn",
    "startlist_empty": "Start list not available yet",
    "tab_insert": "Entry",
    "tab_summary": "Summary",
    "start_list_title": "Start list not ready yet",
    "start_list_sub": "The participant list will be published soon. Check back later.",
    "need_more_one": "Select {{count}} more rider.",
    "need_more_many": "Select {{count}} more riders.",
    "need_more_other": "Select {{count}} more riders.",
    "error_save": "Error while saving.",
    "loading_riders": "Loading riders...",
    "draft_restored": "Draft restored",
    "draft_count_one": "1 rider saved locally",
    "draft_count_many": "{{count}} riders saved locally",
    "draft_count_other": "{{count}} riders saved locally",
    "draft_cancel": "Cancel",
    "select_n_one": "Select {{count}} rider",
    "select_n_many": "Select {{count}} riders",
    "select_n_other": "Select {{count}} riders",
    "add_rider": "+ Add rider ({{current}}/{{limit}})",
    "edit_selection": "Edit selection",
    "apply_all": "Apply selection to all my leagues",
    "saved_for": "Saved for: {{leagues}}",
    "flip_used": "Flip — used",
    "flip_available": "Flip — available",
    "flip_remove": "Remove",
    "flip_abbinato": "{{rider}} paired to slot {{slot}}",
    "flip_confirmed": "The flip has been declared for this stage. The best result will be chosen at scoring time.",
    "flip_slot_label": "Pair the flip to which slot?",
    "flip_confirm_btn": "Confirm flip",
    "saving": "Saving...",
    "confirm_pick": "CONFIRM PICK {{current}}/{{limit}}",
    "select_riders": "Select riders",
    "search_rider": "Search rider...",
    "no_rider_found": "No rider found",
    "compare_users": "Compare users",
    "confirm": "Confirm",
    "no_pick_found": "No picks found.",
    "toast_multi_one": "Picks saved in 1 league",
    "toast_multi_many": "Picks saved in {{count}} leagues",
    "toast_multi_other": "Picks saved in {{count}} leagues",
    "toast_single": "Picks saved!",
    "compare_with": "Compare with {{names}}",
    "compare_default": "Compare with other users (max {{max}})",
    "tap_to_change": "• tap to change",
    "you": "(YOU)",
    "matrix_hint": "Tap a rider to see who picked him",
    "user_col": "User",
    "scout_title": "Scouting Report",
    "scout_top_rider": "Most picked rider",
    "scout_distribution": "Distribution by slot",
    "scout_variety": "League variety",
    "scout_distinct": "Distinct riders selected",
    "scout_identical": "Identical lineups",
    "scout_no_picks": "Submit your picks to see how many have the same lineup as you",
    "loading_lineups": "Loading lineups...",
    "collapse_all": "COLLAPSE ALL",
    "expand_all": "EXPAND ALL",
    "no_races": "No races available right now.",
    "add_rider_one": "+ Add rider ({{current}}/{{limit}})",
    "duplicate_rider": "{{name}} has already been used in a previous stage!",
    "draft_count": "You have {{count}} rider(s) saved locally",
    "toast_multi": "Picks saved in {{count}} leagues",
    "scout_chosen_by": "Picked by: {{names}}",
    "scout_chosen_by_others": "Picked by: {{names}} and {{count}} others",
    "scout_sharing": "Sharing...",
    "scout_share_btn": "Share Scouting Report",
    "scout_outsider": "Outsider",
    "scout_contrarian": "Boldest pick",
    "scout_slot": "SLOT {{n}}",
    "scout_players": "{{count}} players",
    "draft_unsaved_banner": "Pick not confirmed — press Confirm to save",
    "draft_unsaved_title": "Pick not confirmed",
    "draft_unsaved_body": "You have an unsaved selection. Do you want to confirm your pick before leaving?",
    "draft_exit": "Leave without saving",
    "draft_confirm_now": "Stay and confirm",
    "share_all": "All",
    "current_league": "Current league",
    "duplicate_rider_reason": "Already used: {{name}}",
    "flip_saved": "Flip saved!",
    "flip_deleted": "Flip removed.",
    "flip_add_rider": "+ Add flip rider (optional)",
    "riders_count_one": "1 rider",
    "riders_count_many": "{{count}} riders",
    "riders_count_other": "{{count}} riders",
    "riders_selected_one": "1 selected",
    "riders_selected_many": "{{count}} selected",
    "riders_selected_other": "{{count}} selected",
    "search_user": "Search user...",
    "tab_per_tappa": "By stage",
    "tab_matrice": "Rider presence",
    "matrix_select_riders": "Choose riders to track (max 5)",
    "no_picks_riepilogo": "No picks found",
    "no_picks_riepilogo_sub": "You haven't submitted any picks for this race yet.",
    "scout_avg_pct": "~{{pct}}% avg",
    "scout_no_identical": "Nobody else has the same lineup as you",
    "scout_identical_count_one": "1 player has the same lineup as you",
    "scout_identical_count_many": "{{count}} players have the same lineup as you",
    "scout_identical_count_other": "{{count}} players have the same lineup as you",
    "scout_share_dialog": "Scouting Report — {{name}}",
    "share_hidden": "+ {{count}} MORE PLAYERS · OPEN THE APP",
    "no_picks_tabella": "No lineups submitted",
    "no_picks_tabella_sub": "Other players' picks will appear here.",
    "flip_slot_arrow": "→ slot {{slot}}",
    "race_tag_pick": "PICK",
    "race_tag_live": "LIVE",
    "race_tag_done": "DONE",
    "race_switcher_label": "Races",
    "race_history": "Race history",
    "race_group_next": "Upcoming",
    "race_group_past": "Past",
    "close": "Close",
    "prev_stage": "Previous stage",
    "next_stage": "Next stage",
    "stage_list_title": "Stages",
    "matrix_chosen_by": "{{name}} · picked by {{count}} of {{total}}",
    "matrix_clear": "Clear selection",
    "matrix_chosen_by_a11y": "picked by {{count}} of {{total}} players",
    "matrix_open_player": "Open {{name}}'s picks",
    "sheet_chosen_by": "{{count}} of {{total}}",
    "sheet_shared": "Same as you",
    "sheet_unique": "Unique pick",
    "share_label": "THE LINEUPS",
    "share_most_picked": "MOST PICKED",
    "share_unique_picks": "UNIQUE PICKS",
    "share_unique_sub": "riders picked by only one",
    "scout2_title": "Scout",
    "scout2_originality": "YOUR ORIGINALITY",
    "scout2_twin": "YOUR TWIN",
    "scout2_identical": "IDENTICAL LINEUPS",
    "scout2_identical_sub": "players with the same lineup",
    "scout2_bold": "Bold",
    "scout2_balanced": "Balanced",
    "scout2_aligned": "Aligned",
    "scout2_in_common": "{{count}} of {{total}} in common",
    "scout2_none": "None",
    "scout2_popularity": "Rider popularity",
    "scout2_tap_hint": "Tap a rider to highlight him in the table",
    "scout2_your_picks": "Your picks",
    "scout2_also_by": "Also picked by {{names}}",
    "scout2_only_you": "Only you",
    "scout2_outsiders": "Outsiders",
    "finished_banner": "Race finished · you're {{pos}} with {{pts}} pts",
    "finished_banner_nopos": "Race finished",
    "finished_cta": "Standings",
    "scout2_like_you": "Who played like you",
    "scout2_twins_card": "YOUR TWINS",
    "scout2_same_as_you": "{{count}} with your same lineup",
    "scout2_same_picks": "Same lineup",
    "scout2_group_count": "{{count}} players",
    "scout2_no_common": "No riders in common with",
    "scout2_other_identical": "Other identical lineups",
    "result_title": "How it went",
    "result_total": "You scored {{pts}} pts",
    "result_pick_line": "predicted {{slot}}th · finished {{rank}}th",
    "result_dnf": "not classified",
    "result_best": "Your best",
    "result_worst": "Cost you the most",
    "result_malus": "Winner not picked",
    "result_bonus_top10": "All in top 10",
    "result_bonus_top15": "All in top 15",
    "result_winner": "The winner",
    "result_winner_owners": "picked by {{count}} of {{total}}",
    "result_nobody": "Nobody had him",
    "result_difference": "Made the difference",
    "result_difference_sub": "those who had him scored {{delta}} pts on average vs the others",
    "result_flop": "Sank them",
    "result_flop_sub": "those who had him scored {{delta}} pts on average vs the others",
    "rules_title": "Rules at a glance",
    "rules_1": "One rider per stage, three in time trials.",
    "rules_2": "A rider can't be used twice in the same race.",
    "rules_3": "If you miss even one stage you're out of the race: you can follow, but not play.",
    "rules_flip": "Flip: once per race, you name a backup rider; he counts instead of your pick only if he finishes better.",
    "profile_flat": "Flat",
    "profile_hilly": "Hilly",
    "profile_mountain": "Mountain",
    "profile_itt": "Time trial",
    "profile_ttt": "Team time trial",
    "view_by_rider": "By rider",
    "view_by_player": "By player",
    "tour_summary": "{{riders}} riders picked by {{players}} players",
    "your_pick": "Your pick",
    "tour_your_result": "Your result",
    "tour_stage_winner": "Stage winner",
    "stage_finished_banner": "Stage finished · you're {{pos}} on the stage ({{gap}})",
    "share_label_stage": "THE STAGE PICKS",
    "share_distinct_riders": "DIFFERENT RIDERS",
    "scout_t_position": "YOU'RE IN THE",
    "scout_t_break": "BREAKAWAY",
    "scout_t_small": "SMALL GROUP",
    "scout_t_group": "PELOTON",
    "scout_t_with": "with {{count}} players",
    "scout_t_alone": "only you",
    "scout_t_leader": "THE LEADER PICKED",
    "scout_t_jerseys": "The jerseys: what they picked",
    "scout_t_breakaway": "In the breakaway",
    "closes_at": "Closes {{when}}",
    "closes_in": "Closes in {{time}}",
    "profile_title": "Elevation profile",
    "profile_climbs": "Climbs",
    "profile_coppi": "C = Cima Coppi",
    "profile_a11y": "Elevation profile: {{km}} km, highest point {{max}} m, {{n}} main climbs",
    "profile_sprint": "S = intermediate sprint",
    "profile_tap_climb": "Tap a climb for its detail",
    "profile_sprint_bonus": "Sprint · bonus",
    "climb_base": "Base",
    "climb_summit": "Summit",
    "climb_avg": "Average gradient",
    "climb_length": "Length",
    "profile_bonus": "B = bonus point"
  },
  "join": {
    "back_home": "Back to home",
    "welcome": "Welcome to the league!",
    "already_member": "You're already a member of this league.",
    "error": "Unable to join the league.",
    "joining": "Joining league...",
    "success": "Successfully joined!"
  },
  "leaderboard": {
    "stage_cancelled": "Stage {{n}} cancelled: it doesn't count in the standings",
    "loading": "Loading...",
    "no_result_title": "No results",
    "no_result_sub": "The results for this race are not available yet.",
    "gc_rank": "General Classification",
    "team_no_data": "No team data for this stage.",
    "team_title": "TEAM STANDINGS",
    "stage": "Stage {{n}}",
    "general": "General",
    "stage_rank": "Stage {{n}} Standings",
    "no_data_title": "Data unavailable",
    "no_data_sub": "The standings for this stage haven't been calculated yet.",
    "one_day_race": "One Day Race",
    "title": "Leaderboard",
    "no_data": "No data available.",
    "share": "Share",
    "jersey_tempo": "Time",
    "jersey_punti": "Points",
    "jersey_gpm": "KOM",
    "tab_individual": "Individual",
    "tab_team": "Team",
    "share_text": "{{name}}\n\n{{text}}\n\n{{site}}",
    "sharing": "...",
    "race_tag_live": "LIVE",
    "race_tag_done": "DONE",
    "race_tag_soon": "SOON",
    "leader_label": "In the jersey",
    "lead_over_second": "{{gap}} on 2nd",
    "winner": "Winner",
    "sheet_total": "Total",
    "tie": "tied",
    "top10_count": "{{count}} in the top 10",
    "has_winner": "Has the winner",
    "my_rank": "Your position",
    "counts_for_team": "Counts for the team",
    "not_counting": "Does not count",
    "share_label": "STANDINGS",
    "gap_above": "{{gap}} behind {{pos}}th",
    "gap_below": "{{gap}} ahead of {{pos}}th",
    "trend_up": "Up {{n}} places",
    "trend_down": "Down {{n}} places",
    "trend_same": "Position unchanged",
    "sheet_by_stage": "Stage by stage"
  },
  "leagues": {
    "albo": "Hall of Fame",
    "no_podio": "hasn't earned any podiums yet.",
    "victories": "Victories",
    "second": "2nd place",
    "third": "3rd place",
    "races_count_one": "1 race",
    "races_count_many": "{{count}} races",
    "races_count_other": "{{count}} races",
    "player_a": "-- Player A --",
    "player_b": "-- Player B --",
    "draws_one": "1 draw",
    "draws_many": "{{count}} draws",
    "draws_other": "{{count}} draws",
    "on_races_one": "in 1 race",
    "on_races_many": "in {{count}} races",
    "on_races_other": "in {{count}} races",
    "no_common": "No races in common with results.",
    "settings": "SETTINGS",
    "your_position": "Your position",
    "stagionale": "Season Standings",
    "hide": "HIDE",
    "show_all_one": "SHOW ALL (1 more)",
    "show_all_many": "SHOW ALL ({{count}} more)",
    "show_all_other": "SHOW ALL ({{count}} more)",
    "no_data": "No data available yet.",
    "head2head": "Head to Head",
    "races_count": "{{count}} races",
    "draws": "{{count}} draws",
    "on_races": "in {{count}} races",
    "show_all": "SHOW ALL ({{count}} more)",
    "badge_empty_1": "No badges yet — glory awaits! 🚴",
    "badge_empty_2": "Zero achievements so far, but every race is a chance. 💪",
    "badge_empty_3": "No badges yet — great champions all start from zero. 🏅",
    "badge_empty_4": "The first badge is always the hardest. Almost there! ⚡",
    "gap_to_podium": "{{gap}} pts from the podium",
    "gap_to_prev": "{{gap}} pts behind {{pos}}th",
    "lead_over_next": "+{{gap}} pts over {{pos}}nd",
    "invite_title": "Playing alone?",
    "invite_body": "Invite your friends to play together in this league.",
    "invite_cta": "Invite friends",
    "pick_member": "Pick a player",
    "position_a11y": "Position {{pos}}",
    "load_error": "Couldn't load the league.",
    "tab_standings": "Standings",
    "tab_stats": "Stats",
    "tab_rivalry": "Challenges"
  },
  "league": {
    "member_count_one": "1 user in this league",
    "member_count_many": "{{count}} users in this league",
    "member_count_other": "{{count}} users in this league",
    "index_join": "Join",
    "index_create": "Create league",
    "manage_title": "Manage {{name}}",
    "err_name": "Enter a name",
    "err_password": "Enter a password",
    "err_creation": "Error creating league",
    "create_title": "Create new league",
    "create": "Create league",
    "privacy": "Privacy",
    "public": "Public",
    "private": "Private",
    "err_join": "Error or already a member",
    "join_title": "Join a league",
    "search_placeholder": "Search by name...",
    "search": "Search",
    "no_leagues_found": "No leagues found",
    "join_btn": "Join",
    "password_insert": "Enter the password:",
    "calendar_section": "Calendar",
    "calendar_desc_admin": "Manage league races",
    "calendar_desc_user": "Races in calendar",
    "manage": "Manage",
    "view": "View",
    "calendar_title": "League calendar",
    "calendar_save_one": "Save calendar (1 race)",
    "calendar_save_many": "Save calendar ({{count}} races)",
    "calendar_save_other": "Save calendar ({{count}} races)",
    "races_selected_one": "1 race selected",
    "races_selected_many": "{{count}} races selected",
    "races_selected_other": "{{count}} races selected",
    "deselect_all": "Deselect all",
    "select_all": "Select all",
    "loading": "Loading...",
    "settings_section": "League settings",
    "settings_name": "League name",
    "settings_save": "Save",
    "settings_autopick": "Autopick",
    "settings_autopick_desc": "If a user doesn't submit a pick, the system automatically picks the best available rider from the previous stage.",
    "settings_team_race": "Team race",
    "settings_team_race_desc": "Enable team mode for this league.",
    "settings_team_size": "Max members per team",
    "settings_scoring": "Scoring",
    "settings_scoring_best2": "Best 2 — sum of the top two",
    "settings_scoring_avg": "Average of all members",
    "settings_flip": "Flip",
    "settings_flip_desc": "Each user can designate a joker rider for one stage of their choice. At scoring time the best result between the starter and the flip is automatically chosen. Usable once per race.",
    "invite_section": "Invite link",
    "invite_loading": "Loading...",
    "invite_copied": "Copied!",
    "invite_copy": "Copy",
    "invite_share_btn": "Share",
    "members_section": "Members",
    "members_title_admin": "Manage members",
    "members_title_user": "League members",
    "leaving": "Leaving...",
    "leave": "Leave this league",
    "admin_badge": "Admin",
    "remove": "Remove",
    "pick_admin_title": "Pick Correction",
    "pick_admin_desc": "Edit users' picks",
    "pick_admin_open": "Open",
    "pick_admin_save": "Save Picks",
    "pick_admin_none": "— none —",
    "pick_admin_search": "Search rider or number",
    "pick_admin_retired": "retired",
    "pick_admin_saved2": "{{set}} picks set, {{removed}} removed",
    "pick_admin_nochange": "No changes to save",
    "pick_admin_undo": "Undo last correction",
    "pick_admin_undone": "Correction undone",
    "pick_admin_future": "Also removed {{n}} picks from future stages with the same rider",
    "pick_admin_notify": "Notify players",
    "pick_admin_no_calendar": "This race is not in the league calendar: it can't be saved",
    "stats_section": "Statistics",
    "stats_participation": "Participation by stage",
    "stats_title": "Participation statistics",
    "stats_no_data": "No data available.",
    "stats_error": "Couldn't load the statistics. Try again.",
    "team_loading": "Loading teams...",
    "team_section": "Team",
    "team_cancel": "Cancel",
    "team_create_btn": "+ Create team",
    "team_locked": "Race in progress — team changes disabled",
    "team_create": "Create team",
    "team_members_count_one": "1/{{max}} member",
    "team_members_count_many": "{{count}}/{{max}} members",
    "team_members_count_other": "{{count}}/{{max}} members",
    "team_invite_btn": "+ Invite",
    "team_leave": "Leave",
    "team_save": "Save",
    "team_pwd_hint": "Leave empty to make public",
    "team_pending": "Pending response",
    "team_invite_cancel": "Cancel",
    "team_invite_section": "Invite a member",
    "team_no_invitable": "No members available to invite.",
    "team_invite_action": "Invite",
    "team_private_label": "\"{{name}}\" is private:",
    "team_join_action": "Join",
    "team_empty": "No teams yet — be the first to create one!",
    "team_mine": "YOURS",
    "team_join": "Join",
    "team_full": "Full",
    "team_members": "Members",
    "join": "Join",
    "calendar_save": "Save calendar ({{count}} races)",
    "invite_share": "Share",
    "races_selected": "{{count}} races selected",
    "invite_desc": "Share this link — whoever clicks it joins the league directly.",
    "invite_desc_pwd": "Share this link — whoever clicks it joins the league directly with the password included.",
    "member_count": "{{count}} users in this league",
    "team_members_count": "{{count}}/{{max}} members",
    "create_name_placeholder": "E.g.: The Cycling Crew",
    "create_password_placeholder": "Access password",
    "calendar_saved": "Calendar saved!",
    "err_name_empty": "Name cannot be empty",
    "settings_saved": "Settings saved!",
    "pwd_public_placeholder": "Leave empty for public league",
    "invite_share_title": "Join {{name}} on Virtua Cycling",
    "invite_share_message": "Join the league \"{{name}}\" on Virtua Cycling!\n{{url}}",
    "invite_regen_confirm": "Regenerate the link? All previous links will stop working.",
    "invite_regenerating": "Regenerating...",
    "invite_regen_btn": "Regenerate link (revoke previous ones)",
    "confirm_remove": "Remove {{name}} from the league?",
    "member_removed": "{{name}} removed",
    "confirm_demote": "Remove admin privileges from {{name}}?",
    "confirm_promote": "Promote {{name}} to admin?",
    "demote_admin": "Remove Admin",
    "promote_admin": "Admin",
    "pick_admin_saved": "{{count}} picks saved!",
    "confirm_team_leave": "Leave the team?",
    "confirm_kick": "Remove {{name}} from the team?",
    "team_invite_sent": "Invitation sent!",
    "team_pwd_saved": "Password updated!",
    "team_name_placeholder": "Team name...",
    "team_rename_placeholder": "New name...",
    "team_newpwd_placeholder": "New password..."
  },
  "profile": {
    "nick_title": "Nickname",
    "theme_title": "Theme Customization",
    "theme_dark": "Dark",
    "theme_light": "Light",
    "lang": "Language",
    "save_lang": "Save language",
    "nick_success": "Nickname updated!",
    "nick": "Nickname",
    "nick_placeholder": "Enter nickname",
    "update_btn": "Update",
    "pass": "Password",
    "show_pass": "Show password",
    "update_pass": "Update password",
    "avatars_title": "Avatars",
    "avatars": "Show avatars",
    "avatars_sub": "Turn it off if your phone is slow: instead of avatars you'll see the riders' team jerseys and the players' names. Your avatar on the Home screen stays.",
    "notif_title": "Push Notifications",
    "my_leagues": "My leagues",
    "members_count_one": "1 member",
    "members_count_many": "{{count}} members",
    "members_count_other": "{{count}} members",
    "default_badge": "DEFAULT",
    "set_default": "Set default",
    "leave": "Leave",
    "settings": "Profile Settings",
    "hi": "Hi",
    "intro": "here you can manage your account.",
    "admin_panel": "Admin Panel",
    "theme_sub": "Synced across all your devices.",
    "lang_title": "Lingua / Language",
    "security_title": "Security",
    "security_success": "Data updated!",
    "notif_enabled": "Enable notifications",
    "notif_enabled_sub": "Enable or disable all notifications",
    "notif_results": "Race results",
    "notif_results_sub": "Notify when results are published",
    "notif_startlist": "Start list",
    "notif_startlist_sub": "Notify when the start list is available",
    "notif_reminder": "Pick reminder",
    "notif_reminder_sub": "Receive a reminder before picks close",
    "notif_reminder_off": "No reminder",
    "notif_reminder_no_pick": "Only if I haven't picked yet",
    "notif_reminder_always": "Always",
    "notif_saving": "Saving...",
    "notif_saved": "Preferences saved!",
    "notif_error": "Error saving",
    "nick_taken": "Nickname already in use",
    "pass_min_length": "Password must be at least 6 characters",
    "pass_mismatch": "Passwords do not match",
    "new_pass_placeholder": "New password",
    "league_default_updated": "Default league updated!",
    "league_leave_confirm": "Are you sure you want to leave \"{{name}}\"?",
    "league_left": "League left.",
    "confirm_password": "Confirm password",
    "avatar_title": "Your avatar",
    "avatar_jersey": "Jersey",
    "avatar_cap": "Cap",
    "avatar_glasses": "Glasses",
    "avatar_cyclist": "Cyclist",
    "avatar_patch": "Jersey patch",
    "avatar_saved": "Avatar saved!",
    "avatar_save_btn": "Save avatar",
    "rules": "Rules",
    "report_bug": "Report a problem",
    "bug_sent": "Report sent, thank you!",
    "bug_placeholder": "Describe the problem...",
    "group_identity": "Identity",
    "group_account": "Account",
    "group_contact": "Contact us",
    "group_danger": "Danger zone",
    "change_pass": "Change",
    "cancel": "Cancel",
    "show_more": "Show all ({{count}} more)",
    "show_less": "Show less",
    "delete_confirm": "Are you sure you want to delete your account? This action is irreversible and all your data will be permanently deleted.",
    "delete_desc": "Deletion is permanent and removes all your data, picks, leagues and preferences.",
    "delete_btn": "Delete my account",
    "delete_league_owner": "You created a league with other members: deleting your account would remove it for everyone. Contact us to transfer it or delete it first.",
    "replay_tour": "Watch the tour again",
    "leave_feedback": "Leave feedback",
    "feedback_placeholder": "An idea, a suggestion or a comment: we'd love to hear it...",
    "feedback_sent": "Thanks for your feedback! 🙏",
    "rate_app": "Rate Virtua Cycling ⭐"
  },
  "login": {
    "err_nickname": "Enter a nickname",
    "err_nickname_taken": "Nickname already in use",
    "register_ok": "Registration completed! Check your email and confirm your account before logging in.",
    "err_email": "Enter your email",
    "forgot_sent": "Email sent! Check your inbox.",
    "tagline": "Take your place in the team car.",
    "tab_login": "Log in",
    "tab_register": "Register",
    "forgot_hint": "Enter your email and we'll send you a link to reset your password.",
    "email": "Email",
    "forgot_send": "Send link",
    "back": "← Back to login",
    "nickname": "Nickname",
    "password": "Password",
    "btn_login": "LOG IN",
    "btn_register": "REGISTER",
    "forgot_pass": "Forgot password?",
    "or": "or",
    "google_login": "Log in with Google",
    "google_register": "Register with Google",
    "privacy_text": "By continuing you accept our",
    "privacy_link": "Privacy Policy",
    "loading": "…"
  },
  "news": {
    "title": "NEWS",
    "loading": "Loading...",
    "no_news": "No news available.",
    "pinned": "Featured",
    "not_found": "Article not found.",
    "open_external": "Open the article on {{source}}",
    "disclaimer": "Headlines and links come from external sources: the articles belong to their publishers.",
    "tab_unread_one": "{{count}} new article",
    "tab_unread_other": "{{count}} new articles",
    "load_error": "We couldn't load the news."
  },
  "reset_password": {
    "title": "NEW PASSWORD",
    "subtitle": "Choose a new password for your account",
    "show_pass": "Show password",
    "loading": "Verifying link...",
    "success": "Password updated! Redirecting..."
  },
  "confirm": {
    "verifying": "Verifying...",
    "error": "Error during confirmation.",
    "success": "Email confirmed! Redirecting...",
    "missing_params": "Missing parameters in the link.",
    "missing_params_detail": "Make sure you clicked the correct link from your email.",
    "critical_error": "Critical connection error."
  },
  "notifications": {
    "title": "Notifications",
    "empty": "No notifications yet",
    "accept": "Accept",
    "refuse": "Decline",
    "now": "Just now",
    "minutes_ago": "{{count}} min ago",
    "hours_ago": "{{count}}h ago"
  },
  "quiz": {
    "card_sub": "10 questions about the Tour de France — how much do you know?",
    "loading": "Loading questions...",
    "no_questions": "No questions available",
    "question_count": "Question {{current}} of {{total}}",
    "easy": "Easy",
    "medium": "Medium",
    "hard": "Hard",
    "correct": "Correct answer!",
    "wrong": "Wrong. The answer was: {{answer}}",
    "next": "Next",
    "see_result": "See result",
    "restart": "Play again",
    "result_excellent": "You're a true cycling expert!",
    "result_good": "Great knowledge of the Tour de France!",
    "result_average": "Decent knowledge. Watch more races!",
    "result_poor": "Room for improvement — but that's why we ride!"
  },
  "person": {
    "hint": "Choose how your avatar looks: you'll see it on the Home.",
    "gender": "Gender",
    "man": "Man",
    "woman": "Woman",
    "hair_short": "Short",
    "hair_curly": "Curly",
    "hair_wavy": "Wavy",
    "hair_shaved": "Shaved",
    "hair_pixie": "Pixie",
    "hair_bob": "Bob",
    "headwear": "Headwear",
    "wear_none": "None",
    "wear_cap": "Cap",
    "wear_helmet": "Helmet",
    "glasses": "Glasses",
    "glasses_off": "No",
    "glasses_on": "Yes",
    "jersey": "Jersey",
    "jersey_vertical": "Vertical",
    "jersey_horizontal": "Horizontal",
    "jersey_classic": "Classic",
    "jersey_diagonal": "Diagonal",
    "jersey_dots": "Dots",
    "row_skin": "Skin",
    "row_hair": "Hair",
    "row_brow": "Eyebrows",
    "row_iris": "Eyes",
    "row_wear": "Headwear",
    "row_visor": "Peak",
    "row_vents": "Vents",
    "row_frame": "Glasses frame",
    "save": "SAVE",
    "saved": "Avatar saved",
    "save_error": "Error while saving",
    "reset": "Reset",
    "reset_done": "Reset done",
    "tab_face": "Face",
    "tab_hair": "Hair",
    "tab_gear": "Gear",
    "tab_jersey": "Jersey",
    "row_lens": "Lenses",
    "jersey_body": "Body",
    "jersey_sleeves": "Sleeves",
    "jersey_band": "Band",
    "jersey_trim": "Collar & cuffs",
    "view_mine": "My avatar",
    "view_world_champion": "Rainbow jersey",
    "world_champion_since": "World champion in {{league}} since {{date}}",
    "view_european_champion": "European jersey",
    "european_champion_since": "European champion in {{league}} since {{date}}",
    "view_worldcup_leader": "World Cup jersey",
    "worldcup_leader_since": "Leader of the {{league}} standings since {{date}}",
    "kits_show": "Show team kits (admin)",
    "kits_hide": "Hide team kits",
    "kits_hint": "Team jerseys imported from PCS: check colours and design. Kits are fixed in the database.",
    "kits_approx": "approximate",
    "kits_men": "Men",
    "kits_women": "Women",
    "kits_wt": "WorldTeam",
    "kits_pro": "ProTeam",
    "kits_tap": "tap a team to see its riders",
    "kits_no_riders": "No avatars for this team yet.",
    "avatar_edit": "Edit avatar",
    "avatar_cut": "Cut",
    "avatar_hair": "Hair",
    "avatar_skin": "Skin",
    "avatar_beard": "Beard",
    "avatar_beard_none": "None",
    "avatar_face": "Face",
    "avatar_face_none": "Standard",
    "avatar_face_a": "Lean",
    "avatar_face_b": "Strong",
    "avatar_face_c": "Young",
    "avatar_face_d": "Angular",
    "avatar_face_e": "Mature",
    "avatar_face_f": "Smiling",
    "avatar_face_g": "Closed smile",
    "avatar_brow": "Eyebrows",
    "avatar_brow_0": "Normal",
    "avatar_brow_1": "Thin",
    "avatar_brow_2": "Thick",
    "avatar_beard_light": "Light",
    "avatar_hex": "Other colour (#RRGGBB)",
    "avatar_save": "Save",
    "avatar_reset": "Reset",
    "avatar_undo": "Undo last change",
    "avatar_saved": "Saved",
    "avatar_bad_hex": "Invalid colour: use #RRGGBB",
    "avatar_err": "Could not save",
    "avatar_beard_legend": "1 stubble · 2 moustache · 3 short · 4 full · 6 moustache+goatee · 7 circle · 8 light stubble",
    "hair_wavy_medium": "Medium wavy",
    "hair_receding": "Receding",
    "hair_messy": "Messy",
    "hair_buzz": "Buzz cut",
    "hair_curly_short": "Short curls",
    "hair_medium": "Shoulder length",
    "hair_flip_off": "Normal side",
    "hair_flip_on": "Mirrored",
    "hair_side_part": "Side part",
    "hair_slicked_back": "Slicked back",
    "hair_forward": "Forward",
    "hair_high_line": "High hairline",
    "hair_wavy_short": "Short wavy",
    "hair_curly_medium": "Medium curls",
    "hair_receding_short": "Short receding",
    "beard_stubble_light": "Light stubble",
    "hair_long": "Long",
    "hair_ponytail": "Ponytail",
    "hair_bun": "Bun",
    "hair_long_wavy": "Wavy",
    "hair_braid": "Braid",
    "beard": "Beard",
    "beard_none": "None",
    "beard_stubble": "Stubble",
    "beard_moustache": "Moustache",
    "beard_short": "Short",
    "beard_full": "Full",
    "beard_goatee": "Moustache and goatee",
    "beard_circle": "Circle",
    "beard_op_normal": "Normal",
    "beard_op_light": "Light",
    "fringe": "Fringe",
    "fringe_off": "None",
    "fringe_on": "With fringe"
  },
  "app_update": {
    "title": "New version ready",
    "body": "Restart the app to get the latest changes.",
    "restart": "Restart",
    "later": "Later"
  },
  "avatar": {
    "invite_title": "Here's your avatar!",
    "invite_body": "We made one for you: make it yours.",
    "invite_cta": "Customize",
    "invite_dismiss": "Dismiss",
    "edit_a11y": "Customize your avatar"
  },
  "jersey_celebration": {
    "ok": "Awesome!"
  },
  "insight": {
    "you": "With you",
    "form": "Form",
    "never": "Never picked by you: this would be the first time.",
    "picked": "Times picked",
    "avg_rank": "Average finish",
    "avg_gap": "Average gap",
    "best": "Best result",
    "dnf": "Retirements with you",
    "last": "Last time",
    "retired": "retired",
    "form_avg": "Average of last 5",
    "season_races": "Races this season",
    "top10": "Top 10s",
    "wins": "Wins",
    "dnfs": "Retirements",
    "cat_1": "Flat stages",
    "cat_2": "Mountain stages",
    "cat_3": "Hilly stages",
    "last5": "Last 5 results",
    "no_results": "No results yet this season.",
    "open_a11y": "Insights on {{name}}",
    "summary": "{{n}}× with you · avg {{rank}}°",
    "summary_never": "Never picked by you",
    "open": "Insights"
  },
  "badges": {
    "title": "Badges",
    "album_title": "Trophy case",
    "earned_of": "{{earned}} of {{total}} badges",
    "open_album": "Open the trophy case",
    "recent": "Latest earned",
    "next_goals": "Goals within reach",
    "filter_all": "All",
    "filter_earned": "Earned",
    "filter_todo": "To earn",
    "group_gt": "Grand Tours",
    "group_monuments": "Monuments & classics",
    "group_picks": "Pick skills",
    "group_consistency": "Consistency",
    "group_league": "League standings",
    "group_social": "Social",
    "group_meta": "Collection",
    "tier_1": "Bronze",
    "tier_2": "Silver",
    "tier_3": "Gold",
    "tier_4": "Platinum",
    "tier_special": "Milestone",
    "secret_title": "Secret badge",
    "secret_hint": "Find out by playing.",
    "earned_on": "Earned on {{date}}",
    "progress": "{{value}} of {{threshold}}",
    "rarity": "{{pct}}% of the league has it ({{n}} of {{m}})",
    "rarity_none": "Nobody has it yet: you could be the first.",
    "seasons": "Seasons earned: {{count}}",
    "complete": "Completed",
    "locked": "To earn",
    "player": "Player",
    "none_me": "No badges yet: the next race is your chance.",
    "none_other": "{{name}} has no badges yet.",
    "empty_filter": "Nothing to show with this filter.",
    "load_error": "Couldn't load the badges.",
    "not_enabled": "Badges aren't active for this league yet.",
    "fam": {
      "RE_GT": {
        "title": "Grand Tour King",
        "desc": "Grand Tours won: {{n}}"
      },
      "WIN_GIRO": {
        "title": "King of the Giro",
        "desc": "Win the Giro d'Italia general classification"
      },
      "WIN_TOUR": {
        "title": "King of the Tour",
        "desc": "Win the Tour de France general classification"
      },
      "WIN_VUELTA": {
        "title": "King of the Vuelta",
        "desc": "Win the Vuelta general classification"
      },
      "GT_PODI": {
        "title": "Grand Tour Podiums",
        "desc": "Grand Tour podium finishes: {{n}}"
      },
      "GT_DAYS": {
        "title": "Days in the Jersey",
        "desc": "Days as general classification leader: {{n}}"
      },
      "FIRST_PINK": {
        "title": "Pink Jersey",
        "desc": "Take the lead of the Giro d'Italia general classification"
      },
      "FIRST_YELLOW": {
        "title": "Yellow Jersey",
        "desc": "Take the lead of the Tour de France general classification"
      },
      "FIRST_RED": {
        "title": "Red Jersey",
        "desc": "Take the lead of the Vuelta general classification"
      },
      "GT_GREEN": {
        "title": "King of the Sprinters",
        "desc": "Grand Tour points classifications won: {{n}}"
      },
      "GT_POIS": {
        "title": "King of the Mountains",
        "desc": "Grand Tour mountains classifications won: {{n}}"
      },
      "GT_STAGE_WINS": {
        "title": "Stage Hunter",
        "desc": "Grand Tour stages won: {{n}}"
      },
      "GT_WIRE": {
        "title": "Wire to Wire",
        "desc": "Lead the general classification from the first to the last stage and win the Grand Tour"
      },
      "GT_COMEBACK": {
        "title": "Comeback",
        "desc": "Win a Grand Tour while outside the top 10 after the first week"
      },
      "GT_TRIPLE_JERSEY": {
        "title": "Total Triumph",
        "desc": "Win general, points and mountains in the same Grand Tour"
      },
      "GT_HEARTBREAK": {
        "title": "The Heartbreak",
        "desc": "Lead on the eve of the last stage, but miss out on the Grand Tour win"
      },
      "TRIPLE_CROWN": {
        "title": "Triple Crown",
        "desc": "Win the Giro, the Tour and the Vuelta"
      },
      "THE_DOUBLE": {
        "title": "The Double",
        "desc": "Win the Giro and the Tour in the same year"
      },
      "RE_MONUMENTI": {
        "title": "King of the Monuments",
        "desc": "Monuments won: {{n}}"
      },
      "WIN_SANREMO": {
        "title": "La Classicissima",
        "desc": "Win Milano-Sanremo"
      },
      "WIN_FIANDRE": {
        "title": "The Ronde",
        "desc": "Win the Tour of Flanders"
      },
      "WIN_ROUBAIX": {
        "title": "Hell of the North",
        "desc": "Win Paris-Roubaix"
      },
      "WIN_LIEGI": {
        "title": "La Doyenne",
        "desc": "Win Liège-Bastogne-Liège"
      },
      "WIN_LOMBARDIA": {
        "title": "Race of the Falling Leaves",
        "desc": "Win Il Lombardia"
      },
      "MONUMENTS_SWEEP": {
        "title": "The Monuments Sweep",
        "desc": "Win all 5 Monuments"
      },
      "RE_DEL_NORD": {
        "title": "King of the North",
        "desc": "Win Flanders and Roubaix in the same year"
      },
      "ARDENNES": {
        "title": "Ardennes Treble",
        "desc": "Win Amstel, Flèche Wallonne and Liège in the same year"
      },
      "DUE_MARI": {
        "title": "Race of the Two Seas",
        "desc": "Win Paris-Nice and Tirreno-Adriatico in the same year"
      },
      "MODALITA_POGACAR": {
        "title": "Pogačar Mode",
        "desc": "Win all 3 Grand Tours and all 5 Monuments"
      },
      "RE_CLASSICHE": {
        "title": "King of the Classics",
        "desc": "Classics won: {{n}}"
      },
      "RE_TAPPE": {
        "title": "King of the Stage Races",
        "desc": "Stage races won: {{n}}"
      },
      "WORLD_CHAMP": {
        "title": "World Champion",
        "desc": "Win the World Championships road race"
      },
      "EURO_CHAMP": {
        "title": "European Champion",
        "desc": "Win the European Championships road race"
      },
      "CRONOMAN": {
        "title": "Time Trialist",
        "desc": "Win a World or European Championships time trial"
      },
      "SOLO_WIN": {
        "title": "Solo Win",
        "desc": "Only one in the league to pick the winner: {{n}}"
      },
      "PROFETA": {
        "title": "Prophet",
        "desc": "Winning picks: {{n}}"
      },
      "FIUTO": {
        "title": "Sixth Sense",
        "desc": "Winners picked by few: {{n}}"
      },
      "LEAGUE_WINS": {
        "title": "Race Winner",
        "desc": "League races won: {{n}}"
      },
      "LEAGUE_PODI": {
        "title": "Podium Regular",
        "desc": "League race podiums: {{n}}"
      },
      "DEBUTTO": {
        "title": "Debut",
        "desc": "Play your first race"
      },
      "PRESENZE": {
        "title": "Presence",
        "desc": "Races played: {{n}}"
      },
      "SERIE": {
        "title": "On a Streak",
        "desc": "Consecutive races played: {{n}}"
      },
      "STAGIONE_PERFETTA": {
        "title": "Perfect Season",
        "desc": "Play every race of the season"
      },
      "LEADER_STAGIONE": {
        "title": "In Command",
        "desc": "Races finished leading the standings: {{n}}"
      },
      "CAMPIONE_LEGA": {
        "title": "League Champion",
        "desc": "Finish the season top of the standings"
      },
      "PODIO_LEGA": {
        "title": "League Podium",
        "desc": "Finish the season on the podium of the standings"
      },
      "TOP10_LEGA": {
        "title": "Top 10",
        "desc": "Finish the season in the top 10 of the standings"
      },
      "SCALATORE": {
        "title": "Climber",
        "desc": "Places gained in a single race: {{n}}"
      },
      "AMMAZZAGIANTI": {
        "title": "Giant Killer",
        "desc": "Races finished ahead of the standings leader: {{n}}"
      },
      "ALBUM": {
        "title": "Album",
        "desc": "Badges earned: {{n}}"
      },
      "LEGGENDA": {
        "title": "Legend",
        "desc": "Earn every badge"
      }
    },
    "celebration_one": "New badge!",
    "celebration_many": "{{n}} new badges!",
    "celebration_more": "and {{n}} more",
    "share": "Share",
    "share_label": "BADGE EARNED",
    "share_dialog": "My badge: {{name}}",
    "share_text": "I earned the “{{name}}” badge on Virtua Cycling! {{site}}",
    "showcase_title": "Featured",
    "showcase_hint": "Pick up to 3 badges to show off. If you don't pick, we show your rarest ones.",
    "showcase_edit": "Edit",
    "showcase_auto": "Automatic",
    "showcase_save": "Save",
    "showcase_count": "{{n}} of 3 selected",
    "showcase_err": "Couldn't save your selection.",
    "showcase_a11y": "Your featured badges",
    "showcase_none": "Earn your first badge to see it here.",
    "showcase_pick_empty": "You don't have any badges to showcase yet.",
    "jerseys_title": "Grand Tour jerseys",
    "jersey_pink": "Pink jersey",
    "jersey_yellow": "Yellow jersey",
    "jersey_red": "Red jersey",
    "days_caption": "Days in the jersey",
    "section_jerseys": "Jerseys",
    "special_title": "Special jerseys",
    "special_now": "Worn now",
    "trophy_sub": "Badges, jerseys and hall of fame"
  },
  "rivalry": {
    "title": "Challenges",
    "intro": "Pick an opponent. If they accept, from that race on whoever finishes ahead of the other scores the point. The whole league can see how it's going.",
    "slots": "Challenges sent: {{used}} of {{max}}",
    "limit_reached": "You've sent the maximum number of challenges. Cancel or end one to send another.",
    "no_candidates": "There are no other players to challenge.",
    "challenge_cta": "Send a challenge",
    "pick_title": "Who do you want to challenge?",
    "confirm_challenge": "Challenge {{name}}? They'll receive the request and can accept or decline.",
    "sent": "Request sent to {{name}}.",
    "accepted": "You accepted the challenge with {{name}}.",
    "incoming_title": "Requests received",
    "incoming_line": "{{name}} challenges you",
    "accept": "Accept",
    "decline": "Decline",
    "waiting_title": "Waiting for a reply",
    "waiting_line": "Waiting for {{name}}",
    "cancel": "Cancel",
    "mine_title": "Your challenges",
    "league_title": "In the league",
    "ended_title": "Finished challenges: {{count}}",
    "empty": "No challenges in progress in the league. Send the first one!",
    "vs": "vs",
    "score_a11y": "{{a}} to {{b}}",
    "last_point": "Last point: {{name}} in {{race}}",
    "no_races": "No races yet",
    "won_by": "Won by {{name}}",
    "drawn": "Ended in a draw",
    "detail_title": "Challenge",
    "results_title": "Race by race",
    "no_results": "No points awarded yet.",
    "point_to": "Point to {{name}}",
    "end_cta": "End the challenge",
    "end_confirm": "End the challenge with {{name}}?",
    "rematch": "Rematch",
    "load_error": "Couldn't load the challenges.",
    "err_limit": "You've already sent the maximum number of challenges.",
    "err_exists": "You're already in a challenge, or a request is pending.",
    "err_invalid": "This request is no longer valid.",
    "err_generic": "The action couldn't be completed.",
    "notif_accepted": "Challenge accepted",
    "notif_declined": "Challenge declined"
  },
  "competition": {
    "men": "Men Elite",
    "women": "Women Elite",
    "aria": "Competition"
  },
  "no_league": {
    "title": "You're not in any {{comp}} league",
    "body": "You can join a league or create a new one from the Leagues section.",
    "body_official": "You can join the official league whenever you like, or join or create a private league from the Leagues section.",
    "join": "Join {{name}}",
    "go_leagues": "Go to leagues"
  }
}
